import React from 'react';
import PropTypes from 'prop-types';

import { Price, PriceList, VeggieOrVegan, Flags } from './';
import { KCAL } from '../modules/constants';
import { isEmpty } from '../modules/filtering';

/**
 * Menuitem inner component. Used in both the menu list display and the PDP as the data is identical for the most part.
 *
 * @function
 * @param       {object} props props for the menu item.
 * @constructor
 */
function MenuInner(props) {
    const {
        description,
        diets,
        displayName,
        servingInfo,
        flags,
        hideCalories,
        image,
        nandinos,
        nutritionalInfo,
        priceList,
        depositFee,
        short,
        sectionName
    } = props;

    // short - if true we don't display extended price information (menu view).
    // If true we display additional price informat (PDP)

    const sortedNutritionalFacts = [
        ...nutritionalInfo.factsForPortionSizes
    ].sort((a, b) => {
        return a.energyKcal - b.energyKcal;
    });

    let calorieInfo = '';
    if (sortedNutritionalFacts[0] && sectionName !== 'Sharing Platters') {
        calorieInfo = `${sortedNutritionalFacts.length > 1 ? 'From ' : ''}`;
        calorieInfo += `${sortedNutritionalFacts[0].energyKcal} ${KCAL}`;
    }

    const portionInfo = [calorieInfo, servingInfo]
        .filter((i) => !isEmpty(i))
        .join(' | ');

    return (
        <>
            <Flags flags={flags} />
            {image.featured && short ? (
                <div className='inlineimg'>
                    <img
                        loading='lazy'
                        src={image.aspectRatio_16_9.res640x360}
                        alt={image.altText || `Image of ${displayName}`}
                    />
                </div>
            ) : null}
            <h3>{displayName}</h3>
            {
                //<span>{iindex}</span>
            }
            {!hideCalories ? (
                <div className='nutritionalinfo'>
                    <p>{portionInfo}</p>
                </div>
            ) : null}
            <p>{description}</p>
            {nandinos ? null : <Price {...props} />}
            <VeggieOrVegan diets={diets.toString()} />
            {!short && priceList && priceList.length ? (
                <>
                    <PriceList priceList={priceList} depositFee={depositFee} />
                </>
            ) : null}
        </>
    );
}

MenuInner.propTypes = {
    description: PropTypes.string,
    diets: PropTypes.arrayOf(PropTypes.string),
    displayName: PropTypes.string,
    flags: PropTypes.array,
    hideCalories: PropTypes.bool,
    image: PropTypes.object,
    nandinos: PropTypes.bool,
    nutritionalInfo: PropTypes.object,
    short: PropTypes.bool,
    slug: PropTypes.string,
    priceList: PropTypes.arrayOf(PropTypes.object),
    depositFee: PropTypes.shape({
        currencyCode: PropTypes.string,
        value: PropTypes.number
    }),
    sectionName: PropTypes.string,
    servingInfo: PropTypes.string
};

export { MenuInner };
